// i18n strings for the website chrome (Header, Footer, AI assistant, forms)
export const SUPPORTED_LANGS = ["et", "ru", "en"];

export const dict = {
  et: {
    locale: "et-EE",
    nav: {
      home: "Avaleht",
      services: "Teenused",
      diseases: "Haigused",
      pricing: "Hinnakiri",
      doctors: "Arstid/Õed",
      contact: "Kontakt",
      book: "Broneeri aeg",
    },
    diseasesPage: {
      tag: "HAIGUSED",
      title: "Haigused",
      subtitle:
        "Põhjalikud artiklid diabeedi ja kilpnäärme haiguste kohta — diagnostika, ravi ja igapäevased praktilised soovitused.",
      readCta: "Artiklit lugema!",
      diabetesTitle: "Diabeet — artiklid",
      diabetesSubtitle:
        "Loe lähemalt diabeedi, diagnostika, tüsistuste ja ravi kohta.",
      thyroidTitle: "Kilpnäärme haigused — artiklid",
      thyroidSubtitle:
        "Loe lähemalt kilpnäärme haiguste, diagnostika ja ravi kohta meie spetsialiseerunud kliiniku kilpnäärmekliinik.ee blogist.",
    },
    hero: {
      tag: "MEDITSIINILINE TIPPTASE",
      title: "Sinu partner hormonaalse tervise hoidmisel",
      subtitle:
        "Endokrinoloogi, endokriin-, diabeedi- ja jalaõe vastuvõtud Tallinnas ja Pärnus. Osutame Tervisekassa kindlustusega ning tasulisi teenuseid saatekirjata.",
      ctaAI: "Küsi AI Assistendilt",
      ctaBook: "Broneeri vastuvõtt",
    },
    sections: {
      services: { tag: "TEENUSED", title: "Erialased teenused", more: "Loe lähemalt" },
      doctors: { tag: "MEIE TIIM", title: "Meie arstid ja õed", subtitle: "Eksperdid Tallinnas ja Pärnus" },
      pricing: { tag: "HINNAKIRI", title: "Selged hinnad, ilma üllatusteta" },
      locations: { tag: "ASUKOHAD", title: "Tule meile külla" },
      contact: { tag: "VÕTA ÜHENDUST", title: "Helista, kirjuta või broneeri" },
      transit: { tag: "KUIDAS TULLA", title: "Tallinna kliinikusse tulek" },
    },
    form: {
      title: "Saada päring e-postiga",
      subtitle: "Täida vorm, valime õige adressaadi automaatselt.",
      type: "Päringu tüüp",
      types: {
        appointment: "Vastuvõtule registreerimine",
        prescription: "Retsepti soov",
        pedicure_tallinn: "Ravipediküür Tallinnas",
        pedicure_parnu: "Ravipediküür Pärnus",
        cancellation: "Vastuvõtu tühistamine",
        info: "Muu küsimus",
      },
      name: "Sinu nimi",
      email: "E-post",
      phone: "Telefon",
      idCode: "Isikukood",
      idCodeHint: "Vastuvõtu ja retsepti puhul vajalik",
      date: "Soovitav aeg",
      message: "Sõnum",
      submit: "Saada e-mailiga",
      sending: "Saadan…",
      success: "Saadetud! Vastame esimesel võimalusel.",
      error: "Saatmine ebaõnnestus, proovi uuesti või helista.",
      errors: {
        appointment_missing_fields: "Vastuvõtu ajaks on vajalik nimi, isikukood ja telefoninumber.",
        prescription_missing_fields: "Retsepti soovi puhul on vajalik nimi ja isikukood.",
      },
      placeholderMsg: "Kirjelda lühidalt oma soovi…",
      placeholderByType: {
        appointment: "Kirjelda lühidalt oma soovi…",
        prescription: "Palun kirjuta ravimi nimi / nimed, mille retsepti soovid…",
        pedicure_tallinn: "Kirjelda lühidalt oma soovi…",
        pedicure_parnu: "Kirjelda lühidalt oma soovi…",
        cancellation: "Palun märgi vastuvõtu kuupäev ja kellaaeg, mida soovid tühistada…",
        info: "Kirjelda lühidalt oma küsimust…",
      },
    },
    ai: {
      fab: "AI Assistant",
      title: "AI Assistant",
      sub: "Vastame küsimustele hinna, aja ja teenuste kohta",
      placeholder: "Küsi midagi…",
      greeting:
        "Tere! Olen Tallinna Endokrinoloogia Kliiniku virtuaalne abiline. Saan vastata küsimustele hinnakirja, lahtiolekuaegade ja teenuste kohta. Kuidas saan aidata?",
      send: "Saada",
      thinking: "Mõtlen…",
      bookCta: "Saada päring e-postiga",
      newChat: "Uus vestlus",
      live: "AI ASSISTANT",
    },
    footer: {
      tag: "Professionaalne hooldus",
      privacy: "Privaatsus",
      terms: "Tingimused",
      emergency: "Hädaolukord",
      rights: "Kõik õigused kaitstud",
      digital: "Digiregistratuur",
    },
    cta: { call: "Helista", emailUs: "Kirjuta meile" },
  },
  ru: {
    locale: "ru-EE",
    nav: {
      home: "Главная",
      services: "Услуги",
      diseases: "Заболевания",
      pricing: "Цены",
      doctors: "Врачи/Медсёстры",
      contact: "Контакты",
      book: "Записаться",
    },
    diseasesPage: {
      tag: "ЗАБОЛЕВАНИЯ",
      title: "Заболевания",
      subtitle:
        "Подробные статьи о диабете и заболеваниях щитовидной железы — диагностика, лечение и практические рекомендации.",
      readCta: "Читать статью!",
      diabetesTitle: "Диабет — статьи",
      diabetesSubtitle:
        "Подробнее о диабете, диагностике, осложнениях и лечении.",
      thyroidTitle: "Заболевания щитовидной железы — статьи",
      thyroidSubtitle:
        "Подробнее о заболеваниях щитовидной железы, диагностике и лечении в блоге специализированной клиники kilpnäärmekliinik.ee.",
    },
    hero: {
      tag: "МЕДИЦИНСКОЕ ПРЕВОСХОДСТВО",
      title: "Ваш партнёр в гормональном здоровье",
      subtitle:
        "Приёмы эндокринолога, медсестёр по эндокринологии, диабету и стопе в Таллинне и Пярну. Оказываем услуги с медстраховкой Кассы здоровья, а также платные услуги без направления.",
      ctaAI: "Спросить AI Assistant",
      ctaBook: "Записаться на приём",
    },
    sections: {
      services: { tag: "УСЛУГИ", title: "Специализированные услуги", more: "Подробнее" },
      doctors: { tag: "НАША КОМАНДА", title: "Наши врачи и медсёстры", subtitle: "Эксперты в Таллинне и Пярну" },
      pricing: { tag: "ЦЕНЫ", title: "Понятные цены, без сюрпризов" },
      locations: { tag: "АДРЕСА", title: "Приходите к нам" },
      contact: { tag: "СВЯЗАТЬСЯ", title: "Позвоните, напишите или запишитесь" },
      transit: { tag: "КАК ДОБРАТЬСЯ", title: "Как доехать до клиники в Таллинне" },
    },
    form: {
      title: "Отправить запрос по e-mail",
      subtitle: "Заполните форму — мы автоматически выберем правильного получателя.",
      type: "Тип запроса",
      types: {
        appointment: "Запись на приём",
        prescription: "Запрос рецепта",
        pedicure_tallinn: "Педикюр в Таллинне",
        pedicure_parnu: "Педикюр в Пярну",
        cancellation: "Отмена приёма",
        info: "Другой вопрос",
      },
      name: "Ваше имя",
      email: "E-mail",
      phone: "Телефон",
      idCode: "Личный код (isikukood)",
      idCodeHint: "Нужен для записи на приём и для рецепта",
      date: "Желаемое время",
      message: "Сообщение",
      submit: "Отправить по e-mail",
      sending: "Отправка…",
      success: "Отправлено! Ответим при первой возможности.",
      error: "Не удалось отправить, попробуйте ещё раз или позвоните.",
      errors: {
        appointment_missing_fields: "Для записи на приём нужны: имя, личный код (isikukood) и телефон.",
        prescription_missing_fields: "Для запроса рецепта нужны: имя и личный код (isikukood).",
      },
      placeholderMsg: "Кратко опишите ваш запрос…",
      placeholderByType: {
        appointment: "Кратко опишите ваш запрос…",
        prescription: "Пожалуйста, укажите название препарата / препаратов, рецепт на которые нужен…",
        pedicure_tallinn: "Кратко опишите ваш запрос…",
        pedicure_parnu: "Кратко опишите ваш запрос…",
        cancellation: "Укажите дату и время приёма, который нужно отменить…",
        info: "Кратко опишите ваш вопрос…",
      },
    },
    ai: {
      fab: "AI Assistant",
      title: "AI Assistant",
      sub: "Отвечаем о ценах, времени и услугах",
      placeholder: "Спросите что-нибудь…",
      greeting:
        "Здравствуйте! Я виртуальный помощник Таллиннской клиники эндокринологии. Могу ответить о ценах, часах работы и услугах. Чем помочь?",
      send: "Отправить",
      thinking: "Думаю…",
      bookCta: "Отправить запрос по e-mail",
      newChat: "Новый чат",
      live: "AI ASSISTANT",
    },
    footer: {
      tag: "Профессиональный уход",
      privacy: "Конфиденциальность",
      terms: "Условия",
      emergency: "Экстренная помощь",
      rights: "Все права защищены",
      digital: "Цифровая регистратура",
    },
    cta: { call: "Позвонить", emailUs: "Написать нам" },
  },
  en: {
    locale: "en-US",
    nav: {
      home: "Home",
      services: "Services",
      diseases: "Diseases",
      pricing: "Pricing",
      doctors: "Doctors/Nurses",
      contact: "Contact",
      book: "Book a visit",
    },
    diseasesPage: {
      tag: "DISEASES",
      title: "Diseases",
      subtitle:
        "In-depth articles on diabetes and thyroid diseases — diagnosis, treatment and practical everyday advice.",
      readCta: "Read the article!",
      diabetesTitle: "Diabetes — articles",
      diabetesSubtitle:
        "Read more about diabetes, diagnosis, complications and treatment.",
      thyroidTitle: "Thyroid diseases — articles",
      thyroidSubtitle:
        "Learn more about thyroid diseases, diagnosis and treatment on the blog of our specialised clinic kilpnäärmekliinik.ee.",
    },
    hero: {
      tag: "MEDICAL EXCELLENCE",
      title: "Your partner in hormonal health",
      subtitle:
        "Endocrinologist, endocrine, diabetes & foot nurse appointments in Tallinn and Pärnu. We provide services covered by the Estonian Health Insurance Fund as well as paid services without referral.",
      ctaAI: "Ask AI Assistant",
      ctaBook: "Book appointment",
    },
    sections: {
      services: { tag: "SERVICES", title: "Specialized services", more: "Read more" },
      doctors: { tag: "OUR TEAM", title: "Our doctors and nurses", subtitle: "Experts in Tallinn and Pärnu" },
      pricing: { tag: "PRICING", title: "Clear prices, no surprises" },
      locations: { tag: "LOCATIONS", title: "Come visit us" },
      contact: { tag: "GET IN TOUCH", title: "Call, write or book" },
      transit: { tag: "HOW TO REACH US", title: "Getting to our Tallinn clinic" },
    },
    form: {
      title: "Send inquiry by email",
      subtitle: "Fill the form — we route it to the correct recipient automatically.",
      type: "Inquiry type",
      types: {
        appointment: "Book an appointment",
        prescription: "Prescription request",
        pedicure_tallinn: "Medical pedicure Tallinn",
        pedicure_parnu: "Medical pedicure Pärnu",
        cancellation: "Appointment cancellation",
        info: "Other question",
      },
      name: "Your name",
      email: "Email",
      phone: "Phone",
      idCode: "Estonian ID code (isikukood)",
      idCodeHint: "Required for appointments and prescriptions",
      date: "Preferred date",
      message: "Message",
      submit: "Send by email",
      sending: "Sending…",
      success: "Sent! We will reply as soon as possible.",
      error: "Send failed — please retry or call.",
      errors: {
        appointment_missing_fields: "Appointment booking requires: name, Estonian ID code (isikukood) and phone.",
        prescription_missing_fields: "Prescription request requires: name and Estonian ID code (isikukood).",
      },
      placeholderMsg: "Briefly describe your request…",
      placeholderByType: {
        appointment: "Briefly describe your request…",
        prescription: "Please specify the medication name(s) you need a prescription for…",
        pedicure_tallinn: "Briefly describe your request…",
        pedicure_parnu: "Briefly describe your request…",
        cancellation: "Please indicate the date and time of the appointment you wish to cancel…",
        info: "Briefly describe your question…",
      },
    },
    ai: {
      fab: "AI Assistant",
      title: "AI Assistant",
      sub: "Answers about prices, hours and services",
      placeholder: "Ask something…",
      greeting:
        "Hi! I'm the virtual assistant of Tallinn Endocrinology Clinic. I can answer about prices, opening hours and services. How can I help?",
      send: "Send",
      thinking: "Thinking…",
      bookCta: "Send inquiry by email",
      newChat: "New chat",
      live: "AI ASSISTANT",
    },
    footer: {
      tag: "Professional Care",
      privacy: "Privacy",
      terms: "Terms",
      emergency: "Emergency",
      rights: "All rights reserved",
      digital: "Online registration",
    },
    cta: { call: "Call", emailUs: "Email us" },
  },
};

export function pickLang(pathname) {
  if (pathname === "/ru" || pathname.startsWith("/ru/")) return "ru";
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  return "et";
}

export function langPrefix(lang) {
  return lang === "et" ? "" : `/${lang}`;
}
